<template>
  <div class="paymentDeliveryC paymentDelivery">
    <h1>
      Doprava<br />
      a platba
    </h1>

    <section class="col-12-xs col-8-lg">
      <current-step-c class="col-12-xs"></current-step-c>

      <div class="payment__info_wrapper">
        <h2>Zvolte způsob dopravy</h2>
        <section>
          <!-- ⏳ BOOTSTRAP SKELETON: delivery -->
          <template v-if="isLoadingDelivery">
            <div
                class="payment__info_wrapper__item placeholder-row placeholder-wave"
                v-for="n in skeletonCountDelivery"
                :key="'delivery-skel-' + n"
            >
              <span class="placeholder checkbox-ph"></span>

              <div class="payment__info_wrapper__item__textImg">
                <span class="placeholder img-ph"></span>
                <span class="placeholder text-ph"></span>
              </div>

              <span class="placeholder price-ph"></span>
            </div>
          </template>

          <!-- ✅ DATA: delivery -->
          <template v-else>
            <div
                class="payment__info_wrapper__item"
                v-for="deliveryType in deliveryTypes"
                :key="deliveryType.id"
                v-on:click="
                if (deliveryType.id === 2) {
                  openZasilkovnaPickupPoint(deliveryType);
                } else {
                  changeDeliveryType(deliveryType);
                }
              "
            >
              <input
                  type="radio"
                  name="deliveryType"
                  :id="deliveryType.name"
                  :checked="deliveryType.id === storedDeliveryType?.id"
              />
              <label :for="deliveryType.name">
                <font-awesome-icon :icon="['fa', 'check']" />
              </label>
              <div class="payment__info_wrapper__item__textImg">
                <img :src="imageBasePath + deliveryType.image_path" alt="" />
                <span>{{ deliveryType.name }}</span>
              </div>
              <span class="payment__info_wrapper__item__price">{{
                  deliveryType.price
                }}</span>
            </div>
          </template>
        </section>
      </div>

      <div class="payment__info_wrapper">
        <h2>Zvolte způsob platby</h2>
        <section>
          <!-- ⏳ BOOTSTRAP SKELETON: payment -->
          <template v-if="isLoadingPayment">
            <div
                class="payment__info_wrapper__item placeholder-row placeholder-wave"
                v-for="n in skeletonCountPayment"
                :key="'payment-skel-' + n"
            >
              <span class="placeholder checkbox-ph"></span>

              <div class="payment__info_wrapper__item__textImg">
                <span class="placeholder img-ph"></span>
                <span class="placeholder text-ph"></span>
              </div>

              <span class="placeholder price-ph"></span>
            </div>
          </template>

          <!-- ✅ DATA: payment -->
          <template v-else>
            <div
                v-for="paymentType in paymentTypes"
                :key="paymentType.id"
                v-on:click="changePaymentType(paymentType)"
                class="payment__info_wrapper__item"
            >
              <input
                  type="radio"
                  name="paymentType"
                  :id="paymentType.name"
                  :checked="paymentType.id === storedPaymentType?.id"
              />
              <label :for="paymentType.name">
                <font-awesome-icon :icon="['fa', 'check']" />
              </label>
              <div class="payment__info_wrapper__item__textImg">
                <img :src="imageBasePath + paymentType.image_path" alt="" />
                <span>{{ paymentType.name }}</span>
              </div>
              <span class="payment__info_wrapper__item__price">{{
                  paymentType.price
                }}</span>
            </div>
          </template>
        </section>
      </div>
    </section>

    <section class="col-12-xs col-4-lg">
      <summary-price-c page="doprava-a-platba"></summary-price-c>
      <nav-buttons-c
          page="doprava-a-platba"
          pageBefore="/objednavka/kosik"
          pageAfter="/objednavka/informace"
      ></nav-buttons-c>
    </section>
  </div>
</template>

<script>
import currentStepC from "../../components/buyComponents/CurrentStep.vue";
import summaryPriceC from "../../components/buyComponents/SummaryPrice.vue";
import navButtonsC from "../../components/buyComponents/NavButtons.vue";
import axios from "../../api";

export default {
  components: {
    currentStepC,
    summaryPriceC,
    navButtonsC,
  },
  data() {
    return {
      deliveryTypes: [],
      paymentTypes: [],
      priceSummary: 0,
      imageBasePath: process.env.VUE_APP_FITMO_BACKEND_URL,
      packetaApiKey: "APIe6ee80786c2d92b2",
      packetaOptions: {
        valueFormat:
            '"Packeta",id,carrierId,carrierPickupPointId,name,city,street',
      },

      isLoadingDelivery: true,
      isLoadingPayment: true,
      skeletonCountDelivery: 4,
      skeletonCountPayment: 3,
    };
  },

  methods: {
    async loadDeliveryTypesCached() {
      this.isLoadingDelivery = true;

      const cached = this.$store.state.deliveryTypesCache;

      if (cached && cached.length) {
        this.deliveryTypes = cached;
        this.isLoadingDelivery = false;
        return;
      }

      const response = await axios.get("/api/deliveryTypes");
      const mapped = response.data.map((item) => ({
        ...item,
        price: item.price == 0 ? "ZDARMA" : item.price + " Kč",
        priceNumber: item.price,
      }));

      this.deliveryTypes = mapped;
      this.$store.commit("setDeliveryTypesCache", mapped);

      this.isLoadingDelivery = false;
    },

    async loadPaymentTypesCached() {
      this.isLoadingPayment = true;

      const cached = this.$store.state.paymentTypesCache;

      if (cached && cached.length) {
        this.paymentTypes = cached;
        this.isLoadingPayment = false;
        return;
      }

      const response = await axios.get("/api/paymentTypes");
      const mapped = response.data.map((item) => ({
        ...item,
        price: item.price == 0 ? "ZDARMA" : item.price + " Kč",
        priceNumber: item.price,
      }));

      this.paymentTypes = mapped;
      this.$store.commit("setPaymentTypesCache", mapped);

      this.isLoadingPayment = false;
    },

    // ✅ Tohle je klíč: po načtení dat nastav defaulty
    initDefaults() {
      // 1) localStorage
      const lsDelivery = JSON.parse(
          localStorage.getItem("deliveryType") || "null"
      );
      const lsPayment = JSON.parse(
          localStorage.getItem("paymentType") || "null"
      );

      // 2) validace proti datům z API (aby ses neodkazoval na id, které už neexistuje)
      const deliveryExists =
          lsDelivery?.id && this.deliveryTypes.some((d) => d.id === lsDelivery.id);
      const paymentExists =
          lsPayment?.id && this.paymentTypes.some((p) => p.id === lsPayment.id);

      if (deliveryExists) {
        this.$store.commit("updateDeliveryType", lsDelivery);
      } else {
        // default preferuj id=1, jinak první z API
        const defaultDelivery =
            this.deliveryTypes.find((d) => d.id === 1) || this.deliveryTypes[0];

        if (defaultDelivery) this.changeDeliveryType(defaultDelivery);
      }

      if (paymentExists) {
        this.$store.commit("updatePaymentType", lsPayment);
      } else {
        // default preferuj id=1, jinak první z API
        const defaultPayment =
            this.paymentTypes.find((p) => p.id === 1) || this.paymentTypes[0];

        if (defaultPayment) this.changePaymentType(defaultPayment);
      }
    },

    changeDeliveryType(deliveryType) {
      console.log(deliveryType);
      localStorage.removeItem("deliveryType");
      localStorage.setItem(
          "deliveryType",
          JSON.stringify({
            id: deliveryType?.id,
            name: deliveryType?.name,
            price: deliveryType?.price,
            priceNumber: deliveryType?.priceNumber,
            address: deliveryType?.address ?? "",
          })
      );

      const newDeliveryType = {
        id: deliveryType?.id,
        name: deliveryType?.name,
        price: deliveryType?.price,
        priceNumber: deliveryType?.priceNumber,
        address: deliveryType?.address ?? "",
      };

      this.$store.commit("updateDeliveryType", newDeliveryType);
    },

    showSelectedPickupPoint(point) {
      if (point) {
        this.changeDeliveryType(
            this.deliveryTypes.find((item) => {
              if (item.id === 2) {
                item.address = {
                  city: point.city,
                  street: point.street,
                  zip: point.zip,
                  country: point.country,
                  type: "zasilkovna",
                  info: point.place,
                };
              }
              return item.id === 2;
            })
        );
      }
    },

    openZasilkovnaPickupPoint() {
      Packeta.Widget.pick(
          this.packetaApiKey,
          this.showSelectedPickupPoint,
          this.packetaOptions
      );
    },

    changePaymentType(paymentType) {
      localStorage.removeItem("paymentType");
      localStorage.setItem(
          "paymentType",
          JSON.stringify({
            id: paymentType.id,
            price: paymentType.price,
            priceNumber: paymentType.priceNumber,
            name: paymentType.name,
          })
      );

      const newPaymentType = {
        id: paymentType.id,
        price: paymentType.price,
        priceNumber: paymentType.priceNumber,
        name: paymentType.name,
      };

      this.$store.commit("updatePaymentType", newPaymentType);
    },
  },

  watch: {
    cart: {
      immediate: true,
      handler(newCart) {
        if (!newCart || newCart.length === 0) {
          this.$router.replace("/objednavka/kosik");
        }
      },
    },
  },

  computed: {
    cart() {
      return this.$store.state.cart;
    },
    storedPaymentType() {
      return this.$store.state.paymentType;
    },
    storedDeliveryType() {
      return this.$store.state.deliveryType;
    },
  },

  // ✅ důležité: async + pořadí
  async mounted() {
    try {
      await this.loadDeliveryTypesCached();
      await this.loadPaymentTypesCached();
      this.initDefaults();
    } finally {
      // pojistka: kdyby něco spadlo, skeleton nezůstane viset navždy
      this.isLoadingDelivery = false;
      this.isLoadingPayment = false;
    }
  },
};
</script>

<style lang="scss">
.paymentDelivery {
  margin: auto;
  background: $gray-third;
  padding-left: 6%;
  padding-right: 6%;
  justify-content: space-between;

  h1 {
    text-align: left;
    font-size: 2.3rem;
    line-height: 3rem;
    margin-bottom: 2.2rem;
  }
  &__buttons {
    display: flex;
    justify-content: space-between;
    margin: 3rem auto;
    width: 100%;
    align-items: center;
  }
  .btn-yellow {
    padding: 1.3rem 3rem;
    font-size: 1.6rem;
    font-weight: 500;
    border-radius: 3rem;
    display: flex;
    align-items: center;
    margin: 0;
    white-space: nowrap;
    justify-content: space-between;

    img {
      height: 2.7rem;
    }
  }

  &__back {
    margin: 0.6rem 0 3.6rem 0;
  }
  &__back,
  &__buttons__back {
    display: flex;
    align-items: center;
    padding: 0.2rem 2rem;
    font-size: 1.6rem;
    font-weight: 500;
    color: $gray-second;
    border-radius: 3rem;
    height: 100%;
    white-space: nowrap;

    img {
      width: 2.7rem;
      transform: rotate(180deg);
    }
  }
}

/* =========================
   BOOTSTRAP SKELETON (placeholders)
   ========================= */
.paymentDeliveryC {
  .payment__info_wrapper {
    &__item.placeholder-row {
      width: 100%;
      display: flex;
      align-items: center;
      border-radius: 1.4rem;
      pointer-events: none;
      user-select: none;
    }
  }

  .checkbox-ph {
    width: 2.5rem;
    height: 2.5rem;
    border-radius: 0.7rem;
    display: inline-block;
    flex: 0 0 auto;
  }

  .img-ph {
    width: 3.4rem;
    height: 3.4rem;
    border-radius: 0.8rem;
    display: inline-block;
    flex: 0 0 auto;
    margin: 0;
  }

  .text-ph {
    width: 18rem;
    height: 1.6rem;
    border-radius: 0.6rem;
    display: inline-block;
  }

  .price-ph {
    margin-left: auto;
    width: 7rem;
    height: 1.6rem;
    border-radius: 0.6rem;
    display: inline-block;
    flex: 0 0 auto;
  }
}

@media screen and (min-width: $screen-md-min) {
  .paymentDelivery {
    &__currentStep {
      display: flex;
    }
    h1 {
      display: none;
    }
  }

  @media screen and (max-width: $screen-lg-min - 1px) {
    //todo šedé tlačítko
  }
}
.paymentDeliveryC {
  display: flex;
  width: 100%;
  flex-wrap: wrap;
  padding-bottom: 10rem;
  position: relative;
  section {
    display: flex;
    flex-wrap: wrap;
    flex-direction: column;
  }
  label {
    width: 2.5rem;
    height: 2.5rem;
    border-radius: 0.7rem;
    border: 1px solid $gray-second;
    display: flex;
    justify-content: center;
    align-items: center;
    margin: auto 0;

    svg {
      color: $white;
      width: 2rem;
      height: 2rem;
    }
  }
  .payment__info_wrapper {
    &__item {
      width: 100%;

      &:hover {
        input[type="radio"]:checked + label svg {
          color: $white;
        }
      }
    }
  }
  input[type="radio"]:checked + label {
    background: $yellow;
    border: $yellow;
  }
  & > section {
    &:last-child {
      display: flex;
      flex-direction: column-reverse;
    }
  }
}
@media screen and (min-width: $screen-lg-min) {
  .paymentDeliveryC {
    .payment__info_wrapper {
      padding-right: 2rem;
    }
    .paymentDelivery {
      &__buttons {
        flex-direction: column;
        gap: 2rem;
        max-width: 34.5rem;
        align-items: flex-end;
        margin: 3rem 0 3rem auto;
        a {
          width: 100%;

          &.btn-yellow {
            justify-content: center;
          }
        }
      }
    }
    & > section {
      &:last-child {
        flex-direction: column;
      }
    }
  }
}

@media screen and (min-width: $screen-md-min) {
  .paymentDeliveryC {
    .payment__info_wrapper {
    }
    & > section {
      &:last-child {
        margin-bottom: 3rem;
      }
    }
  }

  @media screen and (max-width: $screen-lg-min - 1px) {
    .paymentDeliveryC {
      flex-direction: column-reverse;
      padding-top: 15rem;
      padding-bottom: 13rem;

      .paymentDelivery {
        &__buttons {
          position: absolute;
          bottom: 2rem;
        }
        &__currentStep {
          position: absolute;
          top: 5rem;
          width: 88%;
        }
        &__buttons {
          width: 88%;
          .btn-yellow {
            padding: 1rem 3rem;
            font-size: 1.6rem;
          }
          &__back {
            background: $gray-second;
            color: $white;
            padding: 1rem 3rem;
            font-size: 1.6rem;

            img:first-child {
              display: none;
            }
          }
        }
      }
    }
  }
}
@media screen and (max-width: $screen-md-min - 1px) {
  .paymentDeliveryC {
    .paymentDelivery {
      &__buttons {
        &__back {
          img:last-child {
            display: none;
          }
        }
        .btn-yellow {
          position: absolute;
          bottom: 2rem;
          left: 50%;
          transform: translateX(-50%);
        }
      }
    }
  }
}
</style>
